import { c as classnames } from './index2.js';

/**
 * returns the correct format to use the color in the style
 * @param color{string}
 * @return {string}
 */
const getColor = (color) => {
  return color.includes('--color') || color.includes('--skp') ? `var(${color})` : color;
};
/**
 * returns random value that can be used e.g. do disable autocompletion for some inputs because default "off" property doest always work correctly
 * @return {string}
 */
const getRandomString = () => {
  return String(Math.ceil(Date.now() * Math.random()));
};
const emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
/**
 * returns modificated **classNames** instance, takes prefix as first & required argument and **skpClass** as second & optional (**adds dash after prefix, turns one space string into prefix (' '), does not add prefix to skpClass**)
 * @return {function(): string}
 */
const clsnms = (prefix, skpClass) => (...args) => (classnames(args)
  .split(' ')
  .map((className) => (className === '' ? prefix : prefix + '-' + className))
  .join(' ') +
  ' ' +
  (skpClass ? skpClass : '')).trim();
/**
 * returns instance of above-declared clsnms with pre-defined prefix
 * @return {function(): string}
 */
const localClsnms = (prefix) => (skpClass) => (...args) => clsnms(prefix, skpClass)(args);
/**
 * returns a string with all query parameters connected with &
 * @param queries
 * @return {string}
 */
const parseQueryParams = (queries) => {
  return Object.entries(queries)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};
const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  return new Array(6).fill(null).reduce((color) => color + letters[Math.floor(Math.random() * 10)], '#');
};

export { getRandomString as a, getRandomColor as b, clsnms as c, emailRegex as e, getColor as g, localClsnms as l, parseQueryParams as p };
